import axiosInstance from '../axios.config';

export interface QuoteSyncItem {
  id: number;
  name: string;
  price: number;
  image: string;
  quantity: number;
}

interface QuoteItemsResponse {
  items?: QuoteSyncItem[];
}

interface QuoteAuthConfig {
  token?: string | null;
  nonce?: string | null;
}

const QUOTE_ITEMS_ENDPOINT = '/nex/v1/quotation';

const getQuoteItemsConfig = ({ token, nonce }: QuoteAuthConfig = {}) => ({
  headers: {
    ...(token && token !== 'null' ? { Authorization: `Bearer ${token}` } : {}),
    ...(nonce && nonce !== 'null' ? { 'X-WP-Nonce': nonce } : {}),
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

const normalizeQuoteItemsResponse = (data: unknown): QuoteSyncItem[] => {
  if (Array.isArray(data)) {
    return data as QuoteSyncItem[];
  }

  if (data && typeof data === 'object' && Array.isArray((data as QuoteItemsResponse).items)) {
    return (data as QuoteItemsResponse).items as QuoteSyncItem[];
  }

  return [];
};

export const fetchQuoteItemsFromServer = async (token: string, nonce?: string): Promise<QuoteSyncItem[]> => {
  if ((!token || token === 'null') && (!nonce || nonce === 'null')) {
    return [];
  }

  const response = await axiosInstance.get<QuoteSyncItem[] | QuoteItemsResponse>(
    QUOTE_ITEMS_ENDPOINT,
    getQuoteItemsConfig({ token, nonce })
  );

  return normalizeQuoteItemsResponse(response.data);
};

export const saveQuoteItemsToServer = async (
  items: QuoteSyncItem[],
  token: string,
  nonce?: string
): Promise<QuoteSyncItem[]> => {
  if ((!token || token === 'null') && (!nonce || nonce === 'null')) {
    return items;
  }

  const response = await axiosInstance.post<QuoteSyncItem[] | QuoteItemsResponse>(
    QUOTE_ITEMS_ENDPOINT,
    items,
    getQuoteItemsConfig({ token, nonce })
  );

  const normalizedItems = normalizeQuoteItemsResponse(response.data);
  return normalizedItems.length > 0 ? normalizedItems : items;
};
